export const CONFIG = {
  "PROJECTNAME": "demfood",
  "COMPANYNAME": "Demfood",
  "DFTLNGCODE": "de",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10001121",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": false,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": false,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "#124b2a",
    "primary100": "#ff124b2a",
    "light": "#124b2a",
    "secondary": "#124b2a",
    "dark": "#e0241B",
    "siteColor3": "#fff",
    "menuSecondary": "#124b2a"
  }
};